import React from 'react';
import { Table, Button, Card } from 'react-bootstrap';
import { Users, X } from 'lucide-react'; // Removed unused icons

const ClassListTab = ({
  classes, // These are now already filtered active classes
  loading,
  handleDeleteClass
}) => {
  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0 d-flex align-items-center">
          <Users size={24} className="me-2" />
          All Classes ({classes.length})
        </h5>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <div className="text-center py-4">
            <div className="loading-spinner"></div>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover>
              <thead>
                <tr>
                  <th>Class Name</th>
                  <th>Subjects</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {classes.map((classItem) => (
                  <React.Fragment key={classItem.class_id}>
                    <tr>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="fw-semibold">{classItem.class_name}</span>
                        </div>
                      </td>
                      <td>
                        {classItem.subjects && classItem.subjects.length > 0 ? (
                          <span>
                            {classItem.subjects.map((subject, index) => (
                              <span key={subject.subject_id}>
                                {subject.subject_name}
                                {index < classItem.subjects.length - 1 ? ', ' : ''}
                              </span>
                            ))}
                          </span>
                        ) : (
                          <span className="text-muted">No subjects</span>
                        )}
                      </td>
                      {/* <td>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteClass(classItem.class_id)}
                        >
                          <X size={16} />
                        </Button>
                      </td> */}
                    </tr>
                  </React.Fragment>
                ))}
                {classes.length === 0 && (
                  <tr>
                    <td colSpan="3" className="text-center py-4 text-muted">
                      No active classes found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ClassListTab;